export const getDiscountTypes = (t) => [
  { id: 0, value: 'flatRate', label: t('payment:discountTypes.flatRate') },
  { id: 1, value: 'percentage', label: t('payment:discountTypes.percentage') },
]
